/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { PaginationParams, toHttpParams } from '../model/api/pagination-params';
import { resources } from './api';
import {
    BoardUserData, BoardUsersInfoData, DataRest, IdDataRest,
    NumberArrayData, PaginatedBoardUsers, TextData
} from '../model/api/data-rest';
import { BoardUser, BoardUserDelete, isBadge } from '../model/board-user';


@Injectable({
    providedIn: 'root'
})
export class BoardUsersService {
    constructor(
        private http: HttpClient
    ) {
    }

    getBoardUsers(deviceId: number, nopagination: boolean, paging?: PaginationParams): Observable<PaginatedBoardUsers> {
        let params;
        if (paging) {
            params = toHttpParams(paging);
        } else {
            params = new HttpParams();
        }
        if (nopagination) {
            params = params.set('nopagination', true);
        }
        return this.http.get<PaginatedBoardUsers>(
            `${environment.apiUrl}${resources.get('automations')}/${deviceId}${resources.get('boardUsers')}`,
            { params }
        );
    }

    getBoardUsersInfo(instanceId: number, language?: string): Observable<BoardUsersInfoData> {
        let params = new HttpParams(); // .set('cached', 'true');
        if (language) {
            params = params.set('language', language);
        }
        return this.http.get<BoardUsersInfoData>(
            `${environment.apiUrl}${resources.get('automations')}/${instanceId}${resources.get('boardUsers')}${resources.get('info')}`,
            { params }
        );
    }

    deleteAllBoardUsers(deviceId: number): Observable<DataRest> {
        return this.http.delete<DataRest>(`${environment.apiUrl}${resources.get('automations')}/${deviceId}${resources.get('boardUsers')}`);
    }

    deleteBoardUser(deviceId: number, position: number, code: string): Observable<DataRest> {
        let params = new HttpParams();
        params = params.set('position', position.toString());
        params = params.set('code', code);
        return this.http.delete<DataRest>(
            `${environment.apiUrl}${resources.get('automations')}/${deviceId}${resources.get('boardUsers')}`,
            { params }
        );
    }

    deleteBoardUserSelected(deviceId: number, boardUsers: BoardUserDelete[]): Observable<DataRest> {
        return this.http.post<IdDataRest>(
            `${environment.apiUrl}${resources.get('automations')}/${deviceId}${resources.get('boardUsers')}${resources.get('deletetask')}`,
            { BoardUsers: boardUsers }
        );
    }

    addBoardUser(deviceId: number, boardUser: BoardUser): Observable<IdDataRest> {
        return this.http.post<IdDataRest>(`${environment.apiUrl}${resources.get('automations')}/${deviceId}${resources.get('boardUsers')}`, boardUser);
    }

    editBoardUser(instanceId: number, boardUser: BoardUser, isCodeGroup: boolean): Observable<IdDataRest> {
        if (isCodeGroup) {
            const { Type, TypeDescription, CodeBase, GroupName } = boardUser;
            return this.http.patch<IdDataRest>(
                `${environment.apiUrl}${resources.get('automations')}/${instanceId}${resources.get('boardUsers')}${resources.get('groups')}`,
                { Type, TypeDescription, CodeBase, GroupName }
            );
        } else {
            const { Position, Mode, Name, TypeDescription, Autom1Cmd, Autom2Cmd, Autom3Cmd, Autom4Cmd, GroupId, DateFrom, DateTo } = boardUser;
            if (isBadge(boardUser.Type)) {
                return this.http.patch<IdDataRest>(
                    `${environment.apiUrl}${resources.get('v2')}${resources.get('automations')}/${instanceId}${resources.get('boardUsers')}`,
                    { Position, Mode, Name, TypeDescription, Autom1Cmd, Autom2Cmd, Autom3Cmd, Autom4Cmd, GroupId, DateFrom, DateTo }
                );
            }
            return this.http.patch<IdDataRest>(
                `${environment.apiUrl}${resources.get('v2')}${resources.get('automations')}/${instanceId}${resources.get('boardUsers')}`,
                { Position, Mode, Name, Autom1Cmd, Autom2Cmd, Autom3Cmd, Autom4Cmd, GroupId, DateFrom, DateTo }
            );
        }
    }

    syncBoardUsers(deviceId: number): Observable<IdDataRest> {
        return this.http.get<IdDataRest>(
            `${environment.apiUrl}${resources.get('automations')}/${deviceId}${resources.get('boardUsers')}${resources.get('synctask')}`
        );
    }

    acquireBoardUser(deviceId: number): Observable<BoardUserData> {
        return this.http.get<BoardUserData>(
            `${environment.apiUrl}${resources.get('v2')}${resources.get('automations')}/${deviceId}${resources.get('boardUsers')}${resources.get('acquire')}`
        );
    }

    /* board users import list task */
    addBoardUsers(deviceId: number, boardUsers: BoardUser[]): Observable<IdDataRest> {
        return this.http.post<IdDataRest>(
            `${environment.apiUrl}${resources.get('automations')}/${deviceId}${resources.get('boardUsers')}${resources.get('addtask')}`,
            { BoardUsers: boardUsers }
        );
    }

    exportBoardUsersList(deviceId: number, name: string): Observable<TextData> {
        return this.http.post<TextData>(
            `${environment.apiUrl}${resources.get('automations')}/${deviceId}${resources.get('boardUsersExports')}`,
            { Name: name }
        );
    }

    importBoardusersExport(deviceId: number, exportId: string): Observable<TextData> {
        return this.http.post<TextData>(
            `${environment.apiUrl}${resources.get('automations')}/${deviceId}${resources.get('boardUsersExports')}/${exportId}${resources.get('import')}`,
            {}
        );
    }

    checkBoardusersListCompat(deviceId: number, exportId: string): Observable<NumberArrayData> {
        return this.http.post<NumberArrayData>(
            `${environment.apiUrl}${resources.get('automations')}/${deviceId}${resources.get('boardUsersExports')}/${exportId}${resources.get('check')}`,
            {}
        );
    }
}
